import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchProspect, IProspectApiResponse, prospectActionCreators, ProspectsActionKeys } from '..';
import { addressActionCreators } from '../../address';
import { businessEntityActionCreators } from '../../businessEntity';
import { uiActionCreators } from '../../ui';
import * as api from '../prospectsApi';

function* fetchProspectSaga(action: FetchProspect) {
  yield put(uiActionCreators.showFullPageLoading());
  const prospect: IProspectApiResponse = yield call(api.FetchProspect, action.payload);

  yield put(addressActionCreators.setAddresses(prospect.addresses));
  yield put(
    businessEntityActionCreators.addAddresses([
      {
        addressIds: prospect.addresses.map(x => x.addressId),
        businessEntityId: prospect.businessEntityId
      }
    ])
  );
  yield put(
    businessEntityActionCreators.addNames([{ businessEntityId: prospect.businessEntityId, name: prospect.name }])
  );
  yield put(
    businessEntityActionCreators.setRankType({ beId: prospect.businessEntityId, rankTypeId: prospect.rankTypeId })
  );
  yield put(
    businessEntityActionCreators.setMarketSegments({
      beId: prospect.businessEntityId,
      marketSegmentIds: prospect.marketSegmentIds
    })
  );
  yield put(
    businessEntityActionCreators.setProductCategories({
      beId: prospect.businessEntityId,
      categoryIds: prospect.productCategories
    })
  );
  yield put(uiActionCreators.hideFullPageLoading());
  yield put(prospectActionCreators.setProspects([prospect]));
}

export function* watchFetchProspect() {
  yield takeEvery(ProspectsActionKeys.FETCH_PROSPECT, fetchProspectSaga);
}
